module.exports = __webpack_public_path__ + "files/userImportSample.09c851b3.xls";